{
  "version": 1,
  "asset_id": "7c63c62e-44fa-41d8-8ec0-266d2b32f95c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7c63c62e-44fa-41d8-8ec0-266d2b32f95c/bypass-normal-boxed-es-796.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7c63c62e-44fa-41d8-8ec0-266d2b32f95c/bypass-normal-boxed-es-796.webp",
  "original_filename": "bypass-normal-boxed-es-796.webp",
  "size": 23498,
  "content_type": "image/webp",
  "created_at": "2026-10-06T14:11:38Z"
}
